import React, { forwardRef } from "react";
import './NewsEntry.css' ;
import { Avatar } from '@material-ui/core';

const NewsEntry = forwardRef(
    ({timestamp, user, newsEntry, imageUrl, username, caption}, ref) => {
    return (
        <div className="newsEntry" ref={ref}>
            <div className="newsEntry__header"> 
            <Avatar className="newsEntry__avatar" src={user.photoUrl}/>
            
                <div className="newsEntry__info">
                    <h4>{user.displayName}
                        <span className="message__timestamp">
                        {new Date(timestamp?.toDate()).toUTCString()}
                        </span>
                    </h4>
                    
                </div>
                
            </div>
            <p>{newsEntry}</p>
            <p>{caption}</p>
            <img className="newsEntry__image" src={imageUrl} alt=""/>
        </div>
    )
}
)
export default NewsEntry
